<script setup lang="ts">
defineProps({
    list: Array as PropType<IClientType[]>,
})

defineEmits(['handleOpen'])

const route = useRoute()
const isSoho = computed(() => {
    return !!route.path.includes('dla-firm')
})

export interface IClientType {
    id: string
    text: string
    isActive?: boolean
    url?: string
}

function isActive(item: IClientType): boolean {
    if ((item.id === 'ind' && !isSoho.value) || (item.id === 'soho' && isSoho.value)) {
        return true
    }
    return false
}
</script>

<template>
    <ul
        class="!font-figtree text-lp-label-md md:flex md:justify-end md:gap-4 md:text-lp-label-xs md:font-medium md:leading-5 md:text-plus-lp-dark-blue-300"
    >
        <slot />
        <li
            v-for="item in list"
            :key="item.id"
            class="cursor-pointer pt-6 md:pt-0"
            :class="{ 'md:text-plus-lp-dark-blue': isActive(item) }"
        >
            <a
                :href="item.url"
                class="plus-lp-focus-link !font-figtree"
                @click="$emit('handleOpen', false)"
            >
                {{ item.text }}
            </a>
        </li>
    </ul>
</template>
